import React, { useState } from "react";
import {
  Button,
  Stack,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { exportPDF } from "../utils/pdfExporter";
import { exportExcel } from "../utils/excelExporter";

const ExportButtons = ({ rows = [], selected = [] }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const dataToExport = selected.length > 0 ? selected : rows;

  const columns = [
    { label: "Name", key: "name" },
    { label: "Type", key: "type" },
    { label: "Region", key: "region" },
  ];

  const handlePdfExport = () => {
    exportPDF({
      title: "Crop Report",
      fileName: "crops_export",
      columns,
      data: dataToExport,
    });
    handleClose();
  };

  const handleExcelExport = () => {
    exportExcel({
      fileName: "crops_export",
      columns,
      data: dataToExport,
    });
    handleClose();
  };

  return (
    <Stack direction="row">
      <Button
        variant="outlined"
        endIcon={<KeyboardArrowDownIcon />}
        onClick={handleOpen}
      >
        Export
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handlePdfExport}>
          <ListItemIcon>
            <PictureAsPdfIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Export PDF</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleExcelExport}>
          <ListItemIcon>
            <FileDownloadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Export Excel</ListItemText>
        </MenuItem>
      </Menu>
    </Stack>
  );
};

export default ExportButtons;
